import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { FlexCenter } from '../../../global/commonStyle';

interface OptionCardProps {
  comingSoon?: boolean;
}

const OuterDiv = styled.div`
  position: relative;
  background-color: var(--background-secondary);
  height: 100dvh;
  width: 100%;
`;

const MainDiv = styled.div`
  height: 100%;
  ${FlexCenter}
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;

const NewProjectSection = styled.div`
  max-width: 534px;
  width: 100%;
  padding: var(--space-20);
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-24);
  ${mobile_xl(css`
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: var(--space-2);
  `)}
`;

const TitleSection = styled.div`
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-8);
`;

const Title = styled.p`
  margin: var(--space-0);
  ${Typography.heading_xl_semibold};
  color: var(--text-primary);
`;

const Subtitle = styled.p`
  margin: var(--space-0);
  ${Typography.body_lg};
  color: var(--text-secondary);
`;

const OptionSection = styled.div`
  width: 100%;
  ${FlexCenter}
  gap: var(--space-2);
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    width: calc(100vw - 40px);
    gap: var(--space-12);
  `)}
`;

const OptionCard = styled.div<OptionCardProps>`
  background-color: transparent;
  border: 0.5px solid transparent;
  border-radius: var(--border-radius-12);
  padding: var(--space-20) var(--space-16);
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-12);
  height: 100%;
  &.active:hover {
    cursor: pointer;
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    box-shadow: var(--shadow-card);
    .blank-project {
      background-color: var(--background-tertiary);
    }
  }
  ${mobile_xl(css`
    flex-direction: row;
    background-color: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    padding: var(--space-12);
    width: -webkit-fill-available;
    justify-content: flex-start;
  `)}
`;

const Icon = styled.div`
  ${FlexCenter}
  padding: var(--space-40);
  border: 0.5px solid var(--border-secondary);
  border-radius: var(--border-radius-8);
  &.blank-project {
    border: 0.5px dashed var(--border-secondary);
  }
  &.close-Icon {
    position: absolute;
    top: 20px;
    right: 20px;
    border: unset;
    padding: var(--space-8);
    cursor: pointer;
    &:hover {
      background-color: var(--neutral-secondary);
      svg path {
        fill: var(--text-primary);
      }
    }
  }
  ${mobile_xl(css`
    padding: var(--space-10);
    svg {
      width: 28px;
      height: 28px;
    }
    &.close-Icon {
      position: unset;
      padding: var(--space-6);
      svg {
        width: 20px;
        height: 20px;
      }
    }
  `)}
`;

const OptionCardTitle = styled.p`
  margin: var(--space-0);
  ${Typography.body_md_medium}
  color: var(--text-primary);
`;
const OptionCardDescription = styled.p<OptionCardProps>`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-secondary);
  ${({ comingSoon }) =>
    comingSoon &&
    css`
      white-space: nowrap;
      border: 0.5px solid var(--border-primary);
      border-radius: var(--border-radius-6);
      ${Typography.body_sm}
      padding: var(--space-2)var(--space-4);
    `}
`;

const DescriptionSection = styled.div<OptionCardProps>`
  width: 126px;
  ${FlexCenter}
  flex-direction: column;
  gap: var(--space-4);
  ${mobile_xl(css`
    width: 100%;
    align-items: flex-start;
  `)}
  ${({ comingSoon }) =>
    comingSoon &&
    css`
      gap: var(--space-8);
      ${mobile_xl(css`
        width: 100%;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
      `)}
    `}
`;

export {
  MainDiv,
  NewProjectSection,
  TitleSection,
  Title,
  Subtitle,
  OptionSection,
  OptionCard,
  OptionCardTitle,
  Icon,
  DescriptionSection,
  OptionCardDescription,
  OuterDiv
};
